import { render, staticRenderFns } from "./SaveVersionPopup.vue?vue&type=template&id=3adaa35c&scoped=true"
import script from "./SaveVersionPopup.vue?vue&type=script&lang=js"
export * from "./SaveVersionPopup.vue?vue&type=script&lang=js"
import style0 from "./SaveVersionPopup.vue?vue&type=style&index=0&id=3adaa35c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adaa35c",
  null
  
)

export default component.exports